import { fetcher } from "helpers/fetcher";

import { TGetPendingEODReq, TGetPendingEODRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getPendingEOD = async (payload: TGetPendingEODReq) => {
  return fetcher<TGetPendingEODRes, TGetPendingEODReq>(
    ENDPOINT.MANAGEMENT.GET_PENDING_EOD,
    {
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
      },
    }
  );
};

export const queryGetPendingEOD = async (payload: TGetPendingEODReq) => {
  return (await getPendingEOD(payload)).data;
};

queryGetPendingEOD._key = (payload: TGetPendingEODReq) => [
  ENDPOINT.MANAGEMENT.GET_PENDING_EOD.url,
  payload,
];
